// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// // Your GA measurement ID
// const GA_MEASUREMENT_ID = "G-1M68QLGQPX";

// const Analytics = () => {
//   const location = useLocation();

//   useEffect(() => {
//     // Check if the gtag function is available
//     if (typeof window.gtag === "function") {
//       // Send a pageview event to Google Analytics
//       window.gtag("config", GA_MEASUREMENT_ID, {
//         page_path: location.pathname + location.search,
//       });
//       console.log(`GA Pageview sent for: ${location.pathname + location.search}`);
//     }
//   }, [location]); // Rerun this effect whenever the location changes

//   // This component doesn't render anything to the DOM
//   return null;
// };

// export default Analytics;

// src/Analytics.js
// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// function Analytics() {
//   const location = useLocation();

//   useEffect(() => {
//     const currentUrl = window.location.href;
//     const timestamp = new Date().toISOString();

//     // Get previous list from localStorage
//     const existing = JSON.parse(localStorage.getItem("visitedUrls") || "[]");

//     // Add new entry
//     existing.push({ url: currentUrl, time: timestamp });

//     // Save back
//     localStorage.setItem("visitedUrls", JSON.stringify(existing));

//     console.log("📍 Page tracked:", currentUrl);
//   }, [location]);

//   return null; // This component doesn't render anything
// }

// export default Analytics;

// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// function Analytics() {
//   const location = useLocation();

//   useEffect(() => {
//     async function trackPage() {
//       try {
//         const currentUrl = window.location.href;
//         const timestamp = new Date().toISOString();

//         // Get IP address using public API
//         const ipResponse = await fetch("https://api.ipify.org?format=json");
//         const ipData = await ipResponse.json();
//         const userIp = ipData.ip || "Unknown IP";

//         // Get existing entries
//         const existing = JSON.parse(localStorage.getItem("visitedUrls") || "[]");

//         // Add new entry with IP
//         existing.push({ url: currentUrl, ip: userIp, time: timestamp });

//         // Save back to localStorage
//         localStorage.setItem("visitedUrls", JSON.stringify(existing));

//         console.log("📍 Page tracked:", currentUrl, "| 🌐 IP:", userIp);
//       } catch (error) {
//         console.error("Error tracking analytics:", error);
//       }
//     }

//     trackPage();
//   }, [location]);

//   return null;
// }

// export default Analytics;


import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function Analytics() {
  const location = useLocation();

  useEffect(() => {
    async function trackPage() {
      try {
        const currentUrl = window.location.href;
        const path = location.pathname + location.search;
        const timestamp = new Date().toISOString();

        // --- Google Analytics Tracking ---
        const GA_MEASUREMENT_ID = "G-2ELCGT2TFT"; // Use the correct GA4 Measurement ID
        // Wait for gtag to be available (with timeout)
        const waitForGtag = () => new Promise((resolve) => {
          if (typeof window.gtag === "function") {
            resolve(true);
          } else {
            const checkInterval = setInterval(() => {
              if (typeof window.gtag === "function") {
                clearInterval(checkInterval);
                resolve(true);
              }
            }, 100);
            // Timeout after 3 seconds
            setTimeout(() => {
              clearInterval(checkInterval);
              resolve(false);
            }, 3000);
          }
        });

        const gtagReady = await waitForGtag();
        if (gtagReady) {
          window.gtag("config", GA_MEASUREMENT_ID, { page_path: path });
          console.log(`📊 Google Analytics Pageview sent: ${path}`);
        }

        // --- Custom Analytics Tracking ---
        const ipResponse = await fetch("https://api.ipify.org?format=json");
        const ipData = await ipResponse.json();
        const userIp = ipData.ip || "Unknown IP";

        const existing = JSON.parse(localStorage.getItem("visitedUrls") || "[]");
        existing.push({ url: currentUrl, ip: userIp, time: timestamp });
        localStorage.setItem("visitedUrls", JSON.stringify(existing));

        console.log("📍 Page tracked:", currentUrl, "| 🌐 IP:", userIp);
      } catch (error) {
        console.error("❌ Error tracking analytics:", error);
      }
    }

    trackPage();
  }, [location]);

  return null; // nothing to render
}

export default Analytics;
